import React, { Component } from 'react';
import { Circles } from 'react-loader-spinner'


class Loaders extends Component {
    
    render() {
        return (
    
                 <Circles
  height="80"
  width="80"
  color="#00BFFF"
  ariaLabel="circles-loading"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
/>
               
        );
    }
}

export default Loaders;